module.exports = __webpack_public_path__ + "static/media/header-people.189c772d.svg";